import IcLight from "@/assets/icons/ic-lighthub.svg";

export function AiRecommendationMessage({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className=" overflow-hidden">
      <div className="flex items-start gap-4 p-4 bg-[#EBEBEB] rounded-[4px]">
        <img src={IcLight} alt="Globe Icon" />
        <div className="flex flex-col gap-0.5">
          <span className="text-base font-semibold text-[#000000]">{title}</span>
          <p className="text-base text-[#000000] whitespace-pre-line">{description}</p>
        </div>
      </div>
    </div>
  );
}
